import { activationCodeActionTypes } from './Constants';

export function validateCodeRequest(
	code,
	navigateFromValidationPage = false,
	navigateFromLogin = false,
	validateLicense = false,
) {
	return {
		type: activationCodeActionTypes.VALIDATE_CODE_REQUEST,
		payload: {
			code,
			navigateFromValidationPage,
			navigateFromLogin,
			validateLicense,
		},
	};
}

export function validateCodeSuccess(data) {
	return {
		type: activationCodeActionTypes.VALIDATE_CODE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function validateCodeError(error, data, code, navigateFromValidationPage) {
	return {
		type: activationCodeActionTypes.VALIDATE_CODE_ERROR,
		payload: {
			error,
			data,
			code,
			navigateFromValidationPage,
		},
	};
}
export function activatePackageRequest(codeId) {
	return {
		type: activationCodeActionTypes.ACTIVATE_PACKAGE_REQUEST,
		payload: {
			codeId,
		},
	};
}

export function activatePackageSuccess() {
	return {
		type: activationCodeActionTypes.ACTIVATE_PACKAGE_SUCCESS,
	};
}

export function activatePackageError({ openInvoice }) {
	return {
		type: activationCodeActionTypes.ACTIVATE_PACKAGE_ERROR,
		payload: {
			openInvoice,
		},
	};
}

export function applyCodeRequest(isLicenseApplying) {
	return {
		type: activationCodeActionTypes.APPLY_CODE_REQUEST,
		payload: {
			isLicenseApplying,
		},
	};
}

export function activateLicenseRequest(license) {
	return {
		type: activationCodeActionTypes.ACTIVATE_LICENSE_REQUEST,
		payload: {
			license,
		},
	};
}

export function activateLicenseError() {
	return {
		type: activationCodeActionTypes.ACTIVATE_LICENSE_ERROR,
	};
}
